module.exports = __webpack_public_path__ + "img/system-secret-key.e1da445e.svg";